<div style="overflow-y: auto; max-height: calc(100vh - 8.563rem)">
  @if (!data.isReject && !data.isResubmit) {
    <div style="text-align: center; margin-top: 1.5rem">
      <span style="font-size: 1.688rem; color: #4c4c4c"
        >Are you sure you want to approve the form?</span
      >
    </div>
  }
  @if (data.isReject) {
    <div style="text-align: center; margin-top: 1.5rem">
      <span style="font-size: 1.688rem; color: #4c4c4c"
        >Are you sure you want to reject the form?</span
      >
    </div>
  }
  @if (data.isResubmit) {
    <div style="text-align: center; margin-top: 1.5rem">
      <span style="font-size: 1.688rem; color: #4c4c4c"
        >Are you sure you want to resubmit the form?</span
      >
    </div>
  }
  <div style="text-align: center">
    @if (data.reviewComments && !data.isReject && !data.isResubmit) {
      <div style="color: #696969; margin-top: 1rem">
        <span>Please review your comments and click to approve the form:</span>
      </div>
    }
    @if (data.reviewComments && data.isReject) {
      <div style="color: #696969; margin-top: 1rem">
        <span>Please review your comments and click to reject the form:</span>
      </div>
    }
    @if (data.reviewComments && data.isResubmit) {
      <div style="color: #696969; margin-top: 1rem">
        <span>Please review your comments and click to resubmit the form:</span>
      </div>
    }
    @if (data.reviewComments) {
      <div style="color: #696969; margin-top: 0.5rem">
        <span style="font-style: italic">{{ data.reviewComments }}</span>
      </div>
    }
  </div>
  <div style="text-align: center">
    <div style="display: inline-block; margin-top: 2.625rem; margin-right: 0.875rem">
      <div (click)="closeDialog()" class="exitButton" style="width: 10rem">
        <span class="exitText">BACK</span>
      </div>
    </div>
    @if (!data.isReject && !data.isResubmit) {
      <div style="display: inline-block; margin-top: 2.625rem">
        <button (click)="saveAndClose()" class="confirmButton" style="width: 10rem">
          <span class="confirmText">APPROVE FORM</span>
        </button>
      </div>
    }
    @if (data.isReject) {
      <div style="display: inline-block; margin-top: 2.625rem">
        <button (click)="saveAndClose()" class="rejectButton">
          <span class="confirmText">REJECT FORM</span>
        </button>
      </div>
    }
    @if (data.isResubmit) {
      <div style="display: inline-block; margin-top: 2.625rem">
        <button (click)="saveAndClose()" class="confirmButton" style="width: 10rem">
          <span class="confirmText">SUBMIT FORM</span>
        </button>
      </div>
    }
  </div>
</div>
